import React from 'react';

const DocumentContext = React.createContext();

const DocumentProvider = ({ documents, children }) => {
  return <DocumentContext.Provider value={{ documents }}>{children}</DocumentContext.Provider>;
};

export { DocumentProvider, DocumentContext };
